import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  GET_ALL_ACCA7,
  GET_ALL_ACCA7_RESPONSE_SUCCESS,
  CREATE_ACCA7,
  UPDATE_ACCA7,
  DELETE_ACCA7,
} from "./actionTypes"
import {
  getAllAcca7Call,
  createAcca7Call,
  updateAcca7Call,
  deleteAcca7Call,
  API_URL,
} from "../../helpers/repository"
import {
  getAllAcca7,
  getAllAcca7ResponseSuccess,
} from "./actions"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"

function* attemptGetAllAcca7() {
  try {
    const response = yield call(getAllAcca7Call)
    yield put(getAllAcca7ResponseSuccess(response.data.data))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateAcca7(action) {
  const { history } = action
  try {
    const response = yield call(createAcca7Call, action.payload)
    showMessage("success", response.data.message)
    history.push("/promotions/acca7")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditAcca7(action) {
  const { history, redirectTo } = action
  try {
    const response = yield call(updateAcca7Call, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllAcca7())
    history.push(`/promotions/acca7`)
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeleteAcca7(action) {
  try {
    const response = yield call(deleteAcca7Call, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllAcca7())
  } catch (error) {
    showErrorMessages(error)
  }
}

function* Acca7Saga() {
  yield takeEvery(GET_ALL_ACCA7, attemptGetAllAcca7)
  yield takeEvery(CREATE_ACCA7, attemptCreateAcca7)
  yield takeEvery(UPDATE_ACCA7, attemptEditAcca7)
  yield takeEvery(DELETE_ACCA7, attemptDeleteAcca7)
}

export default Acca7Saga
